<template>
  <div>
    <p class="heading-xs pb-16">Lägg till familjemedlemmar</p>

    <div class="flex flex-row justify-between items-center pb-16">
      <div class="flex flex-row items-center">
        <FamilyConfigurationCounterButton
          aria-label="Ta bort en familjemedlem"
          icon-name="minus"
          :disabled="showDisableDecrement"
          disabled-message="Du måste ha med minst en medlem."
          :show-popover="activePopover === 'decrement'"
          @click="familyStore.decrementFamilyConnections()"
          @show-disabled-message="showPopoverFor('decrement')"
        />

        <div class="me-16">
          <p
            :aria-label="`${familyStore.numberOfFamilyPlanConnections} familjemedlemmar av ${familyStore.allowedNumberOfConnections} möjliga är tillagda`"
          >
            {{ familyStore.numberOfFamilyPlanConnections }}
          </p>
        </div>

        <FamilyConfigurationCounterButton
          aria-label="Lägg till en familjemedlem"
          icon-name="plus"
          :disabled="showDisableIncrement"
          disabled-message="Kan inte lägga till fler medlemmar i det här köpet"
          :show-popover="activePopover === 'increment'"
          @click="familyStore.incrementFamilyConnections()"
          @show-disabled-message="showPopoverFor('increment')"
        />
      </div>
      <div>
        <FamilyConfigurationPriceTextDisplay
          :price="`${familyStore.priceOfAddedFamilyConnections}`"
          :regular-price="`${familyStore.regularPriceOfAddedFamilyConnections || ''}`"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const familyStore = useFamilyStore();

const showDisableDecrement = computed(
  () => familyStore.numberOfFamilyPlanConnections <= 1,
);

const showDisableIncrement = computed(
  () =>
    familyStore.numberOfFamilyPlanConnections >=
    familyStore.allowedNumberOfConnections,
);

const activePopover: Ref<'increment' | 'decrement' | null> = ref(null);
let timeoutId: NodeJS.Timeout | null = null;

const showPopoverFor = (button: 'decrement' | 'increment') => {
  activePopover.value = button;

  if (timeoutId) {
    clearTimeout(timeoutId);
  }

  timeoutId = setTimeout(() => {
    activePopover.value = null;
  }, 3000);
};

onUnmounted(() => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }
});
</script>
